import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StorageDB, StorageItem } from '../../../Interfaces/DataBase/StorageDB';

interface InitialState {
  storage: StorageDB;
  folders: string[];
  selectedFolder?: {
    folderName: string;
    items: StorageItem[];
  };
  selectedItems: StorageItem[];
}

const initialState: InitialState = {
  storage: {},
  folders: [],
  selectedItems: [],
};

const storageSlice = createSlice({
  name: 'StorageSlice',
  initialState: initialState,
  reducers: {
    setStorage: (state, action: PayloadAction<any>) => {
      const temp: StorageDB = {} as StorageDB;
      [...action.payload].forEach((item) => {
        if (temp[item['ParentName']] === undefined) {
          temp[item['ParentName']] = [
            {
              DocumentId: item['DocumentId'],
              DocumentUrl: item['DocumentUrl'],
            },
          ];
        } else {
          temp[item['ParentName']].push({
            DocumentId: item['DocumentId'],
            DocumentUrl: item['DocumentUrl'],
          });
        }
      });

      const folders = Object.keys(temp);
      state.folders = folders;
      state.storage = temp;
    },
    setFolderAndItems: (state, action: PayloadAction<string>) => {
      const items = state.storage[action.payload];
      if (items !== undefined) {
        state.selectedFolder = {
          folderName: action.payload,
          items: [...items],
        };
      } else {
        state.selectedFolder = {
          folderName: action.payload,
          items: [],
        };
      }
    },
  },
});

export const { setStorage, setFolderAndItems } = storageSlice.actions;
export default storageSlice.reducer;
